<template>
  <div class="Container">
    <div class="Progression" :style="styles" />
  </div>
</template>

<script>
export default {
  name: 'LoaderChip',
  props: {
    progression: Number
  },
  computed: {
    styles() {
      return { top: `calc(20px - ${this.progression * 20}px)` }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.Container {
  position: relative;
  height: 30px;
  width: 30px;
  border-radius: 15px;
  background-color: $dark-50;
  overflow: hidden;

  .Progression {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    background-color: $secondary;
  }
}
</style>
